const initSearchDropdown = () => {
    const dropdown = document.querySelector('.search-page .filter-dropdown__container');
    if (!dropdown) return;

    const form = dropdown.closest('form');
    const hiddenInput = form?.querySelector('input[name="post_type"]');
    const valueLabel = dropdown.querySelector('[data-filter-value]');
    const valueDisplay = dropdown.querySelector('.filter-dropdown__value');
    const defaultLabel =
        valueLabel?.dataset.filterDefault ||
        valueDisplay?.dataset.filterDefault ||
        'Post type';
    const buttons = dropdown.querySelectorAll('[data-value]');

    const closeDropdown = () => dropdown.removeAttribute('open');

    const handleOutsideClick = (event) => {
        if (!dropdown.contains(event.target)) {
            closeDropdown();
        }
    };

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            const value = button.dataset.value || '';
            const label = button.dataset.label || button.textContent.trim() || defaultLabel;

            if (hiddenInput) {
                hiddenInput.value = value;
            }

            if (valueLabel) {
                valueLabel.textContent = label;
            }
            if (valueDisplay) {
                valueDisplay.textContent = label;
            }

            closeDropdown();

            if (form) {
                form.submit();
            }
        });
    });

    document.addEventListener('click', handleOutsideClick);
};

export default initSearchDropdown;
